import type { FileExportSource, ImportSource } from "@colossus/contracts";
import { m } from "./paraglide/messages.js";
import type { Message } from "./locale.ts";

const SOURCE_LABEL: Readonly<Record<ImportSource | FileExportSource, Message>> = {
  mee6: m.leveling_source_mee6,
  lurkr: m.leveling_source_lurkr,
  kiai: m.leveling_source_kiai,
  polaris: m.leveling_curve_template_polaris,
  amari: m.leveling_source_amari,
  atlas: m.leveling_source_atlas,
  tatsu: m.leveling_source_tatsu,
  juniper: m.leveling_source_juniper,
  file: m.leveling_source_file,
  roles: m.leveling_source_roles,
  messages: m.leveling_source_messages,
  claims: m.leveling_source_claims,
};

export const importSourceLabel = (source: string): string => {
  const found = (SOURCE_LABEL as Readonly<Record<string, Message | undefined>>)[source];
  return found === undefined ? source : found();
};
